import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { HCreteFileDataToServer } from "@rf-l1/file/helpers/create-file-data-to-server";
import HCheckArray from "@rf-helper/check-have-value";
import { B_RealEstateFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
const prepareDocumentsToServer = (body: IPropertyForm) => {
  const documents: B_RealEstateFormCreateBody["documents"] = {
    title: convertFile(body.file_title_property as IFileData[]),
    captureDetails: convertFile(body.file_capture_details_property as IFileData[]),
    propertyContract: convertFile(
      body.file_property_contract_property as IFileData[]
    ),
    ownerId: convertFile(body.file_owner_id_property as IFileData[]),
    mercantileRegistry: convertFile(
      body.file_commercial_registry_property as IFileData[]
    ),
    propertyPower: convertFile(body.file_power_ownership_property as IFileData[]),
    captureForm: convertFile(body.file_application_form_property as IFileData[])
  };
  return documents;
};

export default prepareDocumentsToServer;

const convertFile = (el: IFileData[]) => {
  if (HCheckArray(el)) {
    return HCreteFileDataToServer(el[0]);
  } else {
    return null;
  }
};
